import { deviceManager } from '../../device/device_manager'
import { dataProfileManage, syncLightModeSetting } from '../../snapshot/profile'
import { type KK } from '../../define/define'
import { type PostKeysColor } from '../../../libs/types/response'

// export interface PostKeysColor {
//     Keys: PostKeyColor[]
//   }

//   export interface PostKeyColor {
//     Key: number
//     Value: number
//   }

export const handleSetCustomColor = async (param: PostKeysColor) => {
  const config = dataProfileManage().dataProfile
  const paramMap = new Map<KK, number>()
  param.Keys.forEach((item) => {
    paramMap.set(item.Key as KK, item.Value)
  })
  config.LightMode.Light = param.Light
  config.LightLastIsCustom = true
  config.ColorsCustom = paramMap
  syncLightModeSetting(config, config.LightMode.Mode, config.LightMode)
  dataProfileManage().save()
  return await deviceManager.deviceDriver.syncCustomColor()
}
